import React from 'react'
import TopSection from './TopSection/TopSection'
import Subscribe from './Down/Subscribe'
import FreeTrial from './FreeTrial/FreeTrial'
import GuessBlogger from './GuessBlogger/GuessBlogger'
import TaskBar from './TaskBar/TaskBar'

const Blog = () => {
  return (
   <>
   <TopSection/>
   <TaskBar/>
   <Subscribe/>
   <FreeTrial/>
   <GuessBlogger/>
   </>
  )
}

export default Blog






 // "Img":"",
  // "main":"",
  // "text":"",
  // "link":"",
  // "img":"",
  // "name":"",
  // "calendar":""